
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __exports as objectGetOwnPropertyNamesExternal } from '../../../_virtual/object-get-own-property-names-external.js';
export { __exports as default } from '../../../_virtual/object-get-own-property-names-external.js';
import classofRaw from './classof-raw.js';
import toIndexedObject$1 from './to-indexed-object.js';
import './object-get-own-property-names.js';
import arraySlice$1 from './array-slice.js';
import { __exports as objectGetOwnPropertyNames } from '../../../_virtual/object-get-own-property-names.js';

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = classofRaw;
var toIndexedObject = toIndexedObject$1;
var $getOwnPropertyNames = objectGetOwnPropertyNames.f;
var arraySlice = arraySlice$1;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};
//# sourceMappingURL=object-get-own-property-names-external.js.map
